import React,{ Component } from 'react';
import InformationSVG from '../../../shared/assets/information.svg';

import {
  FormGroup,
  Label,
  Input,
  Popover,
  PopoverBody,
} from 'reactstrap';

class AudienceRadioInput extends Component {
  constructor(props){
    super(props);
    this.state = {
      mouseOver: false
    }
  }
  render() {
    return (
    <FormGroup check>
      <Label check>
        <Input
          type="radio"
          name={this.props.inputName}
          value={this.props.inputValue}
          checked={this.props.checked}
          onClick={this.props.handleClick}
        />
        &nbsp;&nbsp;{this.props.radioName}
        <span>
          &nbsp;&nbsp;
          <img
            alt='Tooltip information'
            src={InformationSVG}
            id={`tooltip_${this.props.inputValue}`}
            onMouseEnter={() => this.setState({mouseOver: true})}
            onMouseLeave={() => this.setState({mouseOver: false})}
          />
          <Popover
            className='TooltipPopover'
            isOpen={this.state.mouseOver}
            target={'tooltip_' + this.props.inputValue}
            placement='right'
          >
            <PopoverBody>
              {this.props.popover}
            </PopoverBody>
          </Popover>
        </span>
      </Label>
    </FormGroup>
  )
  }
}
export default AudienceRadioInput;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignAudience/components/AudienceRadioInput.js